import { useMyself } from "@api/v1/hooks/useMyself";

const availableIntervalTypes: IntervalType[] = [
  "oneWeek",
  "oneMonth",
  "YTD",
  "oneYear",
  "threeYears",
  "fiveYears",
  "sinceBeginning",
  "custom",
];

const availableCompactIntervalTypes: IntervalType[] = [
  "oneWeek",
  "oneMonth",
  "oneYear",
  "fiveYears",
  "custom",
];

/**
 * Date-range options for the quote/security charts. Pro users additionally get
 * the intraday "oneDay" range. Fed into ChartControlsProvider by the pages.
 */
export const useQuoteDateRanges = () => {
  const { data: myself } = useMyself();
  const isPro = Boolean(myself?.isUserPro);

  return {
    availableDateRanges: isPro
      ? (["oneDay", ...availableIntervalTypes] as IntervalType[])
      : availableIntervalTypes,
    availableCompactDateRanges: isPro
      ? (["oneDay", ...availableCompactIntervalTypes] as IntervalType[])
      : availableCompactIntervalTypes,
  };
};
